const colorPrescriptionInstructions = {
    colors_arr: 
    [
        '#b4f3f3',
        '#9cf0f0',
        '#83ecec',
        '#6ae8e8',
        '#52e5e5',
        '#39e1e1',
        '#20dddd',
        '#08dada',
        '#07c4c4',
        '#06aeae',
        '#059898',
        '#048282',
        '#046d6d',
        '#035757',
    ]
  };
  
  export default colorPrescriptionInstructions;